// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ExpenseConciliationUnlinkDespesaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/expense_conciliation_unlink_despesa/{period_id}/{despesa_id}
 *
 * Unlinks a despesa from a payroll period. No body required — period_id and
 * despesa_id are URL path parameters.
 */
import { registerContract } from './validate'

export interface Payroll_ExpenseConciliationUnlinkDespesaInput {}

registerContract('Payroll_ExpenseConciliationUnlinkDespesaInput', {})
